import { Templates } from '@hellohair/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StepField } from '../_shared/fields';
import { StepDialog, StepEditorProps } from '../_shared/StepDialog';
import { useStepDraft } from '../_shared/useStepDraft';

const SelectFinish: FC<StepEditorProps> = ({ survey, index, onClose }) => {
  const { t } = useTranslation();
  const { draft, set, save, dirty } = useStepDraft<Templates.StepDataSelectFinish>(survey, index);

  return (
    <StepDialog
      survey={survey}
      index={index}
      onSave={save}
      onClose={onClose}
      dirty={dirty}
      edit={
        <>
          <StepField
            label={t('editor.field.message')}
            value={draft.question}
            onChange={(value) => set('question', value)}
            multiline
          />
          <StepField
            label={t('editor.field.extra')}
            value={draft.extra}
            onChange={(value) => set('extra', value)}
            multiline
          />
          <StepField
            label={t('editor.field.content')}
            value={draft.body}
            onChange={(value) => set('body', value)}
            multiline
          />
        </>
      }
      settings={
        <>
          <StepField
            label={t('editor.field.buttonLabel')}
            value={draft.next}
            onChange={(value) => set('next', value)}
          />
          <StepField label={t('editor.field.exitLabel')} value={draft.exit} onChange={(value) => set('exit', value)} />
        </>
      }
    />
  );
};

export default SelectFinish;
